import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box,
} from "@mui/material";
import { TbMenuDeep } from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import './style.css'

const Header = ({ onToggleSidebar }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
  // Clear everything
  localStorage.clear();
  sessionStorage.clear();

  // If you store Redux/Zustand state, reset here too
  // dispatch(logoutUser());

  // Navigate to login and reload to prevent back navigation
  navigate("/login", { replace: true });
  window.location.reload();
};


  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#2d3436", zIndex: (theme) => theme.zIndex.drawer + 1, }}>
      <Toolbar className="d-flex justify-content-between">
        {/* Hamburger Icon for mobile */}
        <Box className="d-flex align-items-center">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2, display: { md: "none" } }}
            onClick={onToggleSidebar}
          >
            <TbMenuDeep />
          </IconButton>
          <Typography variant="h6" noWrap>
            Delivery Boy Panel
          </Typography>
        </Box>

        {/* Profile Avatar */}
        <Box>
          <IconButton onClick={handleMenuOpen} size="large" sx={{ color: "white" }}>
            <Avatar sx={{ bgcolor: "#0984e3" }}>DB</Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem component={Link} to="/deliveryboy/profileSetUp" onClick={handleMenuClose}>
              Profile Setup
            </MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
